// import React from 'react'

// const SetupSupCharges = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default SetupSupCharges


// import React from 'react'

// const CreateSupchargetype = () => {





import { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  TextField,
  Box,
  Breadcrumbs, IconButton,
  Link, Tooltip,Autocomplete,  FormControl,
  InputLabel,  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { PageDataContext } from "../../utils/common/PageDataContext";
import { SETTING_API_04, SUPPLIER_API_10, SUPPLIER_API_11 } from "../../api/ApiModel";
import { externalgetApi } from "../../services/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import { externalpostApi } from "../../services/externalApis";
import { useLocation } from "react-router-dom";
import SystemAlert from "../../components/common/SystemAlert";

function SetupSupCharges() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const [data, setData] = useState(null);
   const [datachar, setDatachar] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const location = useLocation();
  const { selectedItem,suprefcode,supname } = location.state || {};
  const [alertOpen, setAlertOpen] = useState(false); // State to control alert visibility
  const [alertType, setAlertType] = useState("success"); // Type of alert (e.g., success, error, warning)
  const [alertMessage, setAlertMessage] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};
  const {   LOCCODE,STAFFMAPLOCODE, RESTCODE, USERNAME, COMPCODE } = SYS_USER.USER_PARAM || {};
  const isEdit = location.state?.actionText === "Edit";

  const [selectedItemDetails, setSelectedItemDetails] = useState({
    supchargecode:"",
    supchargetype: "",

  supchargetypecode: "",
  chaegerate: "",
  isfixed: "",
 
    
  });

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
       
        supchargetype: selectedItem.supchargetype,
     
    supchargecode: selectedItem.supchargecode,
  
  suprefcode: selectedItem.suprefcode,
  supchargetypecode: selectedItem.supchargetypecode,
  chaegerate: selectedItem.chaegerate || "0",
  isfixed: selectedItem.isfixed || "Y",
      });
    }
  }, [selectedItem]);
  
  const handleCancel = () => {
    setSelectedItemDetails({
      supchargetype: "",
      supchargecode: "",
        chaegerate: "",
  isfixed: "",
    });

  };



 console.log("Selected Item Details:", selectedItemDetails);

  useEffect(() => {
    setPageData({
      title: "Supplier Charges",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  const goBackToView = () => {
    navigate(-1);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;
  
    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }
  
    // Validate max length
    if (typeof value === "string" && value.length > 30) {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot exceed 30 characters.",
      }));
      return;
    }
  
    // Validate empty string
    if (typeof value === "string" && trimmedValue === "") {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }
  
    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

    const handlenumInputChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;
  
    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }
  
    // Validate numeric input (allow integers and floats)
    const isNumeric = /^[0-9]*\.?[0-9]*$/.test(value); // Regular expression to allow numbers with optional decimal points
    if (!isNumeric) {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input must contain only numbers or decimals.",
      }));
      return; // Prevent state update if input is not numeric
    }
  
    // Clear the value if it is "0" when focused
    if (value === "0") {
      setSelectedItemDetails((prevDetails) => ({
        ...prevDetails,
        [name]: "",
      }));
      return;
    }
  
    // Clear error if input is valid
    setError((prevError) => ({
      ...prevError,
      [name]: "",
    }));
  
    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SUPPLIER_API_11, "get", {
          COMPCODE,
            LOCCODE:STAFFMAPLOCODE,


          STS: CON_STATUS_ACTIVE,
        });

        setData(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

    useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SUPPLIER_API_10, "get", {
          COMPCODE,
          LOCCODE:STAFFMAPLOCODE,
         suprefcode:suprefcode,
          STS: CON_STATUS_ACTIVE,
        });

        setDatachar(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);


  const handleConfirmClick = async () => {
    setIsButtonDisabled(true);
    const { supchargetype,supchargecode,chaegerate, isfixed } = selectedItemDetails;

    const requiredFields = [
      { name: "supchargetype", value: supchargetype, label: "Supplier Charge Type" },
        // { name: "chaegerate", value: chaegerate, label: "Charge Rate" },
        //   { name: "isfixed", value: isfixed, label: "Fixed" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });
      setError(newError);

      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      //  const errorMessage = `Required fields: ${missingFieldLabels}.`;
      const errorMessage = `Please Fill All the Required Fields.`;
      setAlertType("error");
      setAlertMessage("Please Fill All the Required Fields.");
      setAlertOpen(true); // Open the alert
      setIsButtonDisabled(false);
      return;
    }

    if (datachar) {
      const isDuplicate = datachar.some((item) => {
        if (
          item.supchargecode !==  selectedItemDetails.supchargecode &&
          item.supchargetype.toLowerCase() === supchargetype.toLowerCase()
        ) {
          return true;
        } else {
          return false;
        }
      });

      if (isDuplicate) {
        setAlertMessage("Supplier Charge Type Already Mapped.");
        setAlertType("warning");

        setAlertOpen(true); // Open the alert
        return;
      }
    }

    const BRAND_CODE = selectedItem ? (selectedItem.supchargecode) :"";
    console.log("Brand Code:", BRAND_CODE);

    const staticValues = {
     endate: new Date().toISOString(),
suprefcode:String(suprefcode),

      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
      supchargecode:  selectedItem.supchargecode || " " ,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi( SUPPLIER_API_10, payload);
      console.log("Success:", responseData);
      setAlertMessage(
        `${isEdit ? "Updated Successfully!" : "Charges Mapped Successfully!"}`
      );
      setAlertType("success");

      setAlertOpen(true);
      setSelectedItemDetails({
        supchargetype: "",
        chaegerate:"",
        isfixed:"",
      });
        setTimeout(() => {
      navigate(-1);
    }, 2000);
    } catch (error) {
      console.error("Error:", error);
      setAlertType("error");
      setAlertMessage("An unexpected error occurred.");
      setAlertOpen(true); // Open the alert
    }
  
  };

  return (
    <>
      <Box sx={styles.box_breadcrumb}>
        <Tooltip title="Back to All Items" arrow sx={styles.breadcrumb_tooltip}>
          <IconButton
            aria-label="back"
            sx={styles.btn_breadcrumb_back}
            onClick={goBackToView}
          >
            <ArrowBackIcon sx={styles.btn_breadcrumb_back_icon} />
          </IconButton>
        </Tooltip>
        <Typography sx={styles.breadcrumb_divider}>|</Typography>

        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            Home
          </Link>
          <Link
            sx={styles.breadcrumb_link}
            underline="hover"
            // href=""
          >
           Supplier Management
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
          Supplier Charges type
          </Link>
        </Breadcrumbs>
      </Box>
      <Box sx={styles.box_add_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 8, sm: 10, md: 10, lg: 10, xl: 10 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}> {isEdit ? "Edit Map Charges" : "Map Charges "}</Typography>
             <Typography sx={{ color: "text.secondary", fontSize: 12 }}>
              {supname}
             </Typography>
            </Grid>
          </Grid>
        </AppBar>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={styles.add_form_page_container}
        >
          <Grid container spacing={2} sx={styles.add_form_page_grid_container}>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <Autocomplete
                options={Array.isArray(data) ? data : []} // Ensure datacat is an array
                getOptionLabel={(option) => option.supchargetype || ""} // Use catname or fallback to an empty string
                disableClearable
                required
                value={
                  Array.isArray(data)
                    ? data.find((item) => item.supchargetypecode === selectedItemDetails.supchargetypecode) || null
                    : null
                } // Match the selected value or fallback to null
                onChange={(event, newValue) => {
                  handleInputChange({
                    target: {
                      name: "supchargetypecode",
                      value: newValue ? newValue.supchargetypecode : "", // Update catcode
                    },
                  });
                  handleInputChange({
                    target: {
                      name: "supchargetype",
                      value: newValue ? newValue.supchargetype : "", // Update catname
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                  {...params}
                  name="supchargetype"
                  label="Supplier Charge Type"
                  variant="outlined"
                  required
                  error={!!error?.supchargetype} // Show error if catname has an issue
                  helperText={error?.supchargetype || ""} // Display the actual error message or fallback to an empty string
                  FormHelperTextProps={{
                    sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                  }}
                  size="small"
                />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}></Grid>

             <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} sx={{ display: "none" }}>
              <TextField
                id="brand-name"
                label="Charge Rate"
                variant="outlined"
                fullWidth
                size="small"
                required
                   name="chaegerate"
                value={selectedItemDetails.chaegerate}
                onChange={handlenumInputChange}
                error={!!error.chaegerate}
                helperText={error.chaegerate}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}></Grid>

             <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 } }sx={{ display: "none" }}>
               <FormControl fullWidth size="small" required error={!!error.isfixed}>
    <InputLabel id="tax-applicable-label">
    Fixed
    </InputLabel>
    <Select
      labelId="tax-applicable-label"
      id="tax-applicable"
      name="isfixed"
      value={selectedItemDetails.isfixed || ""}
      label="Fixed"
      onChange={handleInputChange}
    >
      <MenuItem value="Y">Yes</MenuItem>
      <MenuItem value="N">No</MenuItem>
    </Select>
    {error.isfixed && (
      <FormHelperText sx={{ fontSize: "12px", color: "red" }}>
        {error.isfixed}
      </FormHelperText>
    )}
  </FormControl>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}></Grid>
            
           
          </Grid>
        </Box>
        <Box sx={styles.add_form_page_button_box}>
          <Button
            variant="outlined"
            size="medium"
            sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
            onClick={handleCancel}
      
          >
              Clear
          </Button>
          <Button
            variant="contained"
            size="medium"
            sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
            onClick={handleConfirmClick}
         //   disabled={isButtonDisabled}
          >
           {isEdit ? "Modify" : "Confirm"}
          </Button>
      
        </Box>

        <SystemAlert
          open={alertOpen}
          type={alertType}
          message={alertMessage}
          onClose={() => setAlertOpen(false)}
        />
      </Box>
    </>
  );
}

export default SetupSupCharges;
